import { render } from "./CreateNote.vue?vue&type=template&id=a671ed5c&scoped=true"
import script from "./CreateNote.vue?vue&type=script&lang=js"
export * from "./CreateNote.vue?vue&type=script&lang=js"

import "./CreateNote.vue?vue&type=style&index=0&id=a671ed5c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a671ed5c"]])

export default __exports__